
(function () {

    'use strict';

    /*global $:true */
    // document.domain = 'cologic.de';

    //Annahme: jQuery oder Zepto geladen
    $(document).ready(function () {
        cologic.initAnimation();
    });

    //------------------------------

    let cologicSwCore = {

        isDesktop: false,
        isMobile: false,
        isSmartPhone: false,

        initAnimation: function () {
            // this.startEventTypo();
            this.startAniInit();
            console.log('inANI');
        },


    }

    //gemeinsam verfügbar machen
    if (typeof (cologic) === 'undefined')
        window.cologic = {};
    $.extend(cologic, cologicSwCore);
}());

